const INITIAL_STATE = {
  step: 1,
  firstStep: true,
  document: null,
  customerId: null,
  customerCode: null,
  location: null,
  phoneNumber: null,
  contactId: null,
  password: null,
  confirmPassword: null,
  backPage: null,
  phones:[],
  siteId: null,
  unitId: null,
};

const firstAccessReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  const reducer = {
    TOGGLE_STEP: () => ({ ...state, step: action.step }),
    TOGGLE_FIRST_STEP: () => ({ ...state, firstStep: !!action.firstStep }),
    REGISTER_VALUES: () => ({...state, ...action.object}),
    REGISTER_LOCATON: () => ({...state, location: action.location}),
    REGISTER_DOCUMENT: () => ({ ...state, document: action.document }),
    REGISTER_CUSTOMER_CODE: () => ({ ...state, customerCode: action.customerCode }),
    REGISTER_PHONENUMBER: () => ({ ...state, phoneNumber: action.phoneNumber, contactId: action.contactId }),
    REGISTER_PASSWORD: () => ({ ...state, password: action.phoneNumber, confirmPassword: action.confirmPassword }),
    RESET_STATE: () => ({ ...state, ...INITIAL_STATE }),
  };

  return reducer[type] ? reducer[type]() : { ...state };
};

export default firstAccessReducer;
